import React, { type FunctionComponent } from "react";
import AnalyticsIcon from "components/icons/analytics_icon";
import CapitalIcon from "components/icons/capital_icon";
import CheckmarkIcon from "components/icons/checkmark_icon";
import DailyReviewIcon from "components/icons/daily_review_icon";
import DownArrowIcon from "components/icons/down_arrow_icon";
import DropdownArrowRightIcon from "components/icons/dropdown_arrow_right_icon";
import ExclamationCircleIcon from "components/icons/exclamation_circle_icon";
import FinanceIcon from "components/icons/finance_icon";
import GaugeIcon from "components/icons/gauge_icon";
import GenerateIcon from "components/icons/generate_icon";
import GripIcon from "components/icons/grip_icon";
import InventoryClipboardIcon from "components/icons/inventory_clipboard_icon";
import InventoryIcon from "components/icons/inventory_icon";
import LeftArrowIcon from "components/icons/left_arrow_icon";
import LockIcon from "components/icons/lock_icon";
import LspdMinusCircle from "components/icons/lspd_minus_circle";
import LspdPlusCircle from "components/icons/lspd_plus_circle";
import MinusCircle from "components/icons/minus_circle";
import Plus from "components/icons/plus";
import PlusCircle from "components/icons/plus_circle";
import POSIcon from "components/icons/pos_icon";
import ReportsIcon from "components/icons/reports_icon";
import RightIcon from "components/icons/right_icon";
import SettingsIcon from "components/icons/settings_icon";
import type { ISvgProps } from "components/icons/shared_props";
import SolidStarIcon from "components/icons/solid_star_icon";
import TrustIcon from "components/icons/trust_icon";
import UsersIcon from "components/icons/users_icon";
import type { IColorsInterface } from "styles/colors";
import { type IIconSizeInterface, MAIN_THEME } from "styles/theme";

export enum ICON_TYPE {
  ANALYTICS = "AnalyticsIcon",
  CAPITAL = "CapitalIcon",
  CHECKMARK = "CheckmarkIcon",
  DAILY_REVIEW = "DailyReviewIcon",
  DOWN_ARROW_ICON = "DownArrowIcon",
  DROPDOWN_ARROW_RIGHT = "DropdownArrowRightIcon",
  EXCLAMATION_CIRCLE = "ExclamationCircleIcon",
  FINANCE = "FinanceIcon",
  GAUGE = "GaugeIcon",
  GENERATE = "GenerateIcon",
  GRIP = "GripIcon",
  INVENTORY = "InventoryIcon",
  INVENTORY_CLIPBOARD = "InventoryClipboardIcon",
  LEFT_ARROW = "LeftArrowIcon",
  LOCK = "LockIcon",
  LSPD_MINUS_CIRCLE = "LspdMinusCircle",
  LSPD_PLUS_CIRCLE = "LspdPlusCircle",
  MINUS_CIRCLE = "MinusCircle",
  PLUS = "Plus",
  PLUS_CIRCLE = "PlusCircle",
  POS = "POSIcon",
  REPORTS = "ReportsIcon",
  RIGHT_ICON = "RightIcon",
  SETTINGS = "SettingsIcon",
  SOLID_STAR_ICON = "SolidStarIcon",
  TRUST = "TrustIcon",
  USERS = "UsersIcon",
}
type IconComponents = { [key in ICON_TYPE]: FunctionComponent<ISvgProps> };

const ICON_COMPONENTS: IconComponents = {
  AnalyticsIcon,
  CapitalIcon,
  CheckmarkIcon,
  DailyReviewIcon,
  DownArrowIcon,
  DropdownArrowRightIcon,
  ExclamationCircleIcon,
  FinanceIcon,
  GaugeIcon,
  GenerateIcon,
  GripIcon,
  InventoryClipboardIcon,
  InventoryIcon,
  LeftArrowIcon,
  LockIcon,
  LspdMinusCircle,
  LspdPlusCircle,
  MinusCircle,
  Plus,
  PlusCircle,
  POSIcon,
  ReportsIcon,
  RightIcon,
  SettingsIcon,
  SolidStarIcon,
  TrustIcon,
  UsersIcon,
};

interface IIconProps extends ISvgProps {
  type: ICON_TYPE;
}

/**
 * @deprecated Please import the icon directly.
 */
export default function Icon({
  color = MAIN_THEME.colors.brandGray30,
  size = MAIN_THEME.iconSize.small,
  type,
}: IIconProps) {
  const DynamicIcon = ICON_COMPONENTS[type];
  if (color in MAIN_THEME.colors) {
    color = MAIN_THEME.colors[color as keyof IColorsInterface];
  }
  if (size in MAIN_THEME.iconSize) {
    size = MAIN_THEME.iconSize[size as keyof IIconSizeInterface];
  }
  return <DynamicIcon color={color} size={size} />;
}
